import { useEffect, useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAuthStore } from '@/store/authStore';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const hasHydrated = useAuthStore((state) => state.hasHydrated);
  const validateSession = useAuthStore((state) => state.validateSession);
  const location = useLocation();
  const hasValidated = useRef(false);

  useEffect(() => {
    if (hasHydrated && isAuthenticated && !hasValidated.current) {
      hasValidated.current = true;
      void validateSession();
    }
  }, [hasHydrated, isAuthenticated, validateSession]);

  // Wait for store hydration before making auth decisions
  if (!hasHydrated) {
    return (
      <div className='flex items-center justify-center min-h-[50vh]'>
        <div className='animate-spin rounded-full h-8 w-8 border-b-2 border-primary' />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to='/login' state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
